import { useState } from 'react';
import { usersAPI } from '../services/api';
import { resolveDirectoryPasswordTarget } from '../domain/user/directoryPasswordTarget';
import { useLoadBatches } from './useLoadBatches';

/**
 * Filter Students row actions: change batch + dedicated password reset.
 */
export function useFilterStudentRowActions() {
  const { batches, loadBatches } = useLoadBatches();
  const [changeBatchStudent, setChangeBatchStudent] = useState(null);
  const [passwordStudent, setPasswordStudent] = useState(null);

  const openChangeBatch = async (student) => {
    if (!student?.enrollments?.length) return;
    setChangeBatchStudent(student);
    await loadBatches();
  };

  const openChangePassword = (student) => {
    setPasswordStudent(student);
  };

  const submitDirectoryPassword = async (password) => {
    const row = passwordStudent;
    if (!row) return;
    const target = resolveDirectoryPasswordTarget(row);
    if (!target.ok) {
      throw new Error(target.error);
    }
    if (target.userId) {
      await usersAPI.changePassword(target.userId, { password });
      return;
    }
    const userRes = await usersAPI.getByEmail(target.email);
    const userId = userRes.data?.id;
    if (!userId) {
      throw new Error('Could not find a login account for this student.');
    }
    await usersAPI.changePassword(userId, { password });
  };

  return {
    batches,
    changeBatchStudent,
    passwordStudent,
    openChangeBatch,
    openChangePassword,
    closeChangeBatch: () => setChangeBatchStudent(null),
    closeChangePassword: () => setPasswordStudent(null),
    submitDirectoryPassword,
  };
}
